module.exports = __webpack_public_path__ + "static/media/ArrowRight.00f6fbbd.svg";